import { useNavigate } from "react-router-dom";
import Button from "../../Components/Button";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function AlertModal({ open, onClose, path }) {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate(path);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <p className="text-center text-xl font-semibold mb-4">Requesting LOA</p>
        <p className="text-[#60656D] text-center mb-4">
          LOA requests submitted through Member Portal will be processed and reviewed within 24 hours. For urgent LOA requests, please contact our Customer Care Hotline at (02) 858251900 or (02) 77987777.
        </p>
        <Button className="w-full text-white" onClick={handleProceed}>
          Ok
        </Button>
      </div>
    </Modal>
  );
}

AlertModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
};

export default AlertModal;
